var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('shop-product-box',{attrs:{"product":_vm.product}}),(_vm.loading)?_c('div',{staticClass:"spinner auto-center"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }